// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/modules/Courier/pages/Route/ReceiptInfo/ReceiptInfo.module.css */
.ReceiptInfo_cardContainer__s5nVn {
  position: relative;
  margin-bottom: 8px;
  overflow: hidden;
  /* height auto to fit products */
}
.ReceiptInfo_underlay__fxI32 {
  position: absolute;
  top: 0; bottom: 0; left: 0; right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  pointer-events: none;
}

/* левая «кнопка» (свайп вправо) */
.ReceiptInfo_primaryUnderlay__LNzK5 {
  background: #007bff;
  color: #fff;
  padding: 0 50px;         /* здесь регулируете ширину кнопки */
  height: 100%;            /* и высоту (по контейнеру) */
  display: flex;
  align-items: center;
  font-size: 0.85em;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

/* правая «кнопка» (свайп влево) */
.ReceiptInfo_secondaryUnderlay__zXSNf {
  background: #dc3545;
  color: #fff;
  padding: 0 50px;         /* ширина правой кнопки */
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 0.85em;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/* ReceiptInfo.module.css */

.ReceiptInfo_primaryScan__hBjxd        { background: #007bff; } /* Сканировать */
.ReceiptInfo_primaryMakeCheck__i7X9O   { background: #ffc107; } /* Сформировать чек */
.ReceiptInfo_primaryViewCheck__Tv6MQ   { background: #28a745; } /* Посмотреть чек */
.ReceiptInfo_primaryClose__UUKKv       { background: #28a745; } /* Закрыть */
.ReceiptInfo_primaryReturn__YM\\+fA      { background: #fd7e14; } /* Вернуть */

.ReceiptInfo_secondaryFail__exFfN      {background: #dc3545; } /* Не доставлено */
.ReceiptInfo_secondaryReturn__t6wj-    {background: #17a2b8; } /* Вернуть (для закрытой) */


.ReceiptInfo_slider__GwWbc {
  position: relative;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
  transition: transform 0.2s ease-out;
  overflow: hidden;
}
.ReceiptInfo_indicator__MlhZQ {
  position: absolute;
  left: 0; top: 0; bottom: 0;
  width: 5px;
  border-radius: 4px 0 0 4px;
}

.ReceiptInfo_row__\\+wsyp {
  display: flex;
  align-items: center;
  height: 28px;
  padding: 0 8px;
  font-size: 0.85em;
}
.ReceiptInfo_address__GV0ZF {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1em;       /* было 0.85em — увеличили до 1em */
  font-weight: 500;     /* добавили немного жирности для читаемости */
}
.ReceiptInfo_payment__s73Fw {
  margin-left: 8px;
  white-space: nowrap;
  color: #555;
}

.ReceiptInfo_productRow__BqahE {
  display: inline-block;      /* контейнер “упаковывается” по содержимому */
  position: relative;
  align-items: center;
  height: 24px;
  left: 10px;

  margin-right: 10px;
  font-size: 0.85em;
}

.ReceiptInfo_productContainer__9srsz {
  /* уже существующие у вас стили */
  position: relative;
  display: inline-flex;
  align-items: center;
  /* ... */

  /* вот он — отступ между блоками */
  margin-bottom: 8px;
}

.ReceiptInfo_textWrapper__euP0F {
  display: inline-flex;       /* текст в строку */
  align-items: center;
}

.ReceiptInfo_productName__Rnrvt {
  flex: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #fff;
  mix-blend-mode: difference;
}

.ReceiptInfo_productQty__\\+VhvO {
  flex: none;
  margin-left: 8px;
  color: #fff;
  mix-blend-mode: difference;
}

.ReceiptInfo_progressBase__41SM6 {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;                /* тянется на всю ширину контейнера */
  height: 5px;
  background: #e0e0e0;     /* или любой другой серый */
  border-radius: 2px;
  z-index: 0;
}

.ReceiptInfo_progressBg__hgTnn {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 5px;
  background: rgb(28, 192, 28);
  border-radius: 2px;
  z-index: 0;
}
.ReceiptInfo_time__WoqD- {
  color: #666;
}

.ReceiptInfo_rowBottom__I5\\+5j {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 28px;
  padding: 0 8px;
  font-size: 0.85em;
}

.ReceiptInfo_rowInfo__LaTJw {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ReceiptInfo_rowActions__Q81XJ {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ReceiptInfo_bi-map__YB\\+Lf,
.ReceiptInfo_bi-file-earmark-text__SNON\\+ {
  font-size: 1.6em; /* увеличенный размер */
  color: #007bff;
  cursor: pointer;
}

.ReceiptInfo_icon__obzjt {
  font-size: 2em;
  color: #007bff;
  cursor: pointer;
}

/* подсветка активной карточки 
.activeCard {
  position: relative;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.7);
  border-radius: 4px ;
}*/

/* иконка прицела */
.ReceiptInfo_targetIcon__Ny-V\\+ {
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 1.2rem;
  color: rgb(0, 123, 255);
  z-index: 2;
}

/* порядковый номер */
.ReceiptInfo_sequenceNumber__19lky {
  margin-right: 5px;
  font-size: 0.9rem;
  font-weight: bold;
  color: #007bff;
}

/* зелёный для следующей квитанции */
.ReceiptInfo_nextSequence__xM9EK {
  color: #ffffff;
  font-weight: bold;
  background-color: #1eff00;
  border-radius: 5px;
  padding-left: 3px;
  padding-right: 3px;

}

/* бледный для закрытых и «Не доставлено» */
.ReceiptInfo_fadedSequence__\\+usqI {
  opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Courier/Route/ReceiptInfo/ReceiptInfo.module.css"],"names":[],"mappings":"AAAA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,MAAM,EAAE,SAAS,EAAE,OAAO,EAAE,QAAQ;EACpC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe,UAAU,oCAAoC;EAC7D,YAAY,aAAa,6BAA6B;EACtD,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe,UAAU,yBAAyB;EAClD,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,2BAA2B;;AAE3B,yCAAsB,mBAAmB,EAAE,EAAE,gBAAgB;AAC7D,yCAAsB,mBAAmB,EAAE,EAAE,qBAAqB;AAClE,yCAAsB,mBAAmB,EAAE,EAAE,mBAAmB;AAChE,yCAAsB,mBAAmB,EAAE,EAAE,YAAY;AACzD,0CAAsB,mBAAmB,EAAE,EAAE,YAAY;;AAEzD,wCAAqB,mBAAmB,EAAE,EAAE,kBAAkB;AAC9D,wCAAqB,mBAAmB,EAAE,EAAE,2BAA2B;;;AAGvE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,OAAO,EAAE,MAAM,EAAE,SAAS;EAC1B,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc,QAAQ,mCAAmC;EACzD,gBAAgB,MAAM,6CAA6C;AACrE;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB,OAAO,6CAA6C;EACzE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,UAAU;;EAEV,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;;EAER,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB,QAAQ,mBAAmB;EAC/C,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ,iBAAiB,qCAAqC;EAC9D,WAAW;EACX,mBAAmB,MAAM,2BAA2B;EACpD,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,gBAAgB,EAAE,uBAAuB;EACzC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;EAKE;;AAEF,mBAAmB;AACnB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;AACZ;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;;AAEpB;;AAEA,2CAA2C;AAC3C;EACE,YAAY;AACd","sourcesContent":["/* src/modules/Courier/pages/Route/ReceiptInfo/ReceiptInfo.module.css */\r\n.cardContainer {\r\n  position: relative;\r\n  margin-bottom: 8px;\r\n  overflow: hidden;\r\n  /* height auto to fit products */\r\n}\r\n.underlay {\r\n  position: absolute;\r\n  top: 0; bottom: 0; left: 0; right: 0;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  pointer-events: none;\r\n}\r\n\r\n/* левая «кнопка» (свайп вправо) */\r\n.primaryUnderlay {\r\n  background: #007bff;\r\n  color: #fff;\r\n  padding: 0 50px;         /* здесь регулируете ширину кнопки */\r\n  height: 100%;            /* и высоту (по контейнеру) */\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 0.85em;\r\n  border-top-left-radius: 4px;\r\n  border-bottom-left-radius: 4px;\r\n}\r\n\r\n/* правая «кнопка» (свайп влево) */\r\n.secondaryUnderlay {\r\n  background: #dc3545;\r\n  color: #fff;\r\n  padding: 0 50px;         /* ширина правой кнопки */\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 0.85em;\r\n  border-top-right-radius: 4px;\r\n  border-bottom-right-radius: 4px;\r\n}\r\n\r\n/* ReceiptInfo.module.css */\r\n\r\n.primaryScan        { background: #007bff; } /* Сканировать */\r\n.primaryMakeCheck   { background: #ffc107; } /* Сформировать чек */\r\n.primaryViewCheck   { background: #28a745; } /* Посмотреть чек */\r\n.primaryClose       { background: #28a745; } /* Закрыть */\r\n.primaryReturn      { background: #fd7e14; } /* Вернуть */\r\n\r\n.secondaryFail      {background: #dc3545; } /* Не доставлено */\r\n.secondaryReturn    {background: #17a2b8; } /* Вернуть (для закрытой) */\r\n\r\n\r\n.slider {\r\n  position: relative;\r\n  background: #fff;\r\n  border-radius: 4px;\r\n  box-shadow: 0 1px 2px rgba(0,0,0,0.1);\r\n  transition: transform 0.2s ease-out;\r\n  overflow: hidden;\r\n}\r\n.indicator {\r\n  position: absolute;\r\n  left: 0; top: 0; bottom: 0;\r\n  width: 5px;\r\n  border-radius: 4px 0 0 4px;\r\n}\r\n\r\n.row {\r\n  display: flex;\r\n  align-items: center;\r\n  height: 28px;\r\n  padding: 0 8px;\r\n  font-size: 0.85em;\r\n}\r\n.address {\r\n  flex: 1;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  font-size: 1em;       /* было 0.85em — увеличили до 1em */\r\n  font-weight: 500;     /* добавили немного жирности для читаемости */\r\n}\r\n.payment {\r\n  margin-left: 8px;\r\n  white-space: nowrap;\r\n  color: #555;\r\n}\r\n\r\n.productRow {\r\n  display: inline-block;      /* контейнер “упаковывается” по содержимому */\r\n  position: relative;\r\n  align-items: center;\r\n  height: 24px;\r\n  left: 10px;\r\n\r\n  margin-right: 10px;\r\n  font-size: 0.85em;\r\n}\r\n\r\n.productContainer {\r\n  /* уже существующие у вас стили */\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  /* ... */\r\n\r\n  /* вот он — отступ между блоками */\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.textWrapper {\r\n  display: inline-flex;       /* текст в строку */\r\n  align-items: center;\r\n}\r\n\r\n.productName {\r\n  flex: none;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  color: #fff;\r\n  mix-blend-mode: difference;\r\n}\r\n\r\n.productQty {\r\n  flex: none;\r\n  margin-left: 8px;\r\n  color: #fff;\r\n  mix-blend-mode: difference;\r\n}\r\n\r\n.progressBase {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;                /* тянется на всю ширину контейнера */\r\n  height: 5px;\r\n  background: #e0e0e0;     /* или любой другой серый */\r\n  border-radius: 2px;\r\n  z-index: 0;\r\n}\r\n\r\n.progressBg {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  height: 5px;\r\n  background: rgb(28, 192, 28);\r\n  border-radius: 2px;\r\n  z-index: 0;\r\n}\r\n.time {\r\n  color: #666;\r\n}\r\n\r\n.rowBottom {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  height: 28px;\r\n  padding: 0 8px;\r\n  font-size: 0.85em;\r\n}\r\n\r\n.rowInfo {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.rowActions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.bi-map,\r\n.bi-file-earmark-text {\r\n  font-size: 1.6em; /* увеличенный размер */\r\n  color: #007bff;\r\n  cursor: pointer;\r\n}\r\n\r\n.icon {\r\n  font-size: 2em;\r\n  color: #007bff;\r\n  cursor: pointer;\r\n}\r\n\r\n/* подсветка активной карточки \r\n.activeCard {\r\n  position: relative;\r\n  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.7);\r\n  border-radius: 4px ;\r\n}*/\r\n\r\n/* иконка прицела */\r\n.targetIcon {\r\n  position: absolute;\r\n  top: 8px;\r\n  right: 8px;\r\n  font-size: 1.2rem;\r\n  color: rgb(0, 123, 255);\r\n  z-index: 2;\r\n}\r\n\r\n/* порядковый номер */\r\n.sequenceNumber {\r\n  margin-right: 5px;\r\n  font-size: 0.9rem;\r\n  font-weight: bold;\r\n  color: #007bff;\r\n}\r\n\r\n/* зелёный для следующей квитанции */\r\n.nextSequence {\r\n  color: #ffffff;\r\n  font-weight: bold;\r\n  background-color: #1eff00;\r\n  border-radius: 5px;\r\n  padding-left: 3px;\r\n  padding-right: 3px;\r\n\r\n}\r\n\r\n/* бледный для закрытых и «Не доставлено» */\r\n.fadedSequence {\r\n  opacity: 0.5;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardContainer": `ReceiptInfo_cardContainer__s5nVn`,
	"underlay": `ReceiptInfo_underlay__fxI32`,
	"primaryUnderlay": `ReceiptInfo_primaryUnderlay__LNzK5`,
	"secondaryUnderlay": `ReceiptInfo_secondaryUnderlay__zXSNf`,
	"primaryScan": `ReceiptInfo_primaryScan__hBjxd`,
	"primaryMakeCheck": `ReceiptInfo_primaryMakeCheck__i7X9O`,
	"primaryViewCheck": `ReceiptInfo_primaryViewCheck__Tv6MQ`,
	"primaryClose": `ReceiptInfo_primaryClose__UUKKv`,
	"primaryReturn": `ReceiptInfo_primaryReturn__YM+fA`,
	"secondaryFail": `ReceiptInfo_secondaryFail__exFfN`,
	"secondaryReturn": `ReceiptInfo_secondaryReturn__t6wj-`,
	"slider": `ReceiptInfo_slider__GwWbc`,
	"indicator": `ReceiptInfo_indicator__MlhZQ`,
	"row": `ReceiptInfo_row__+wsyp`,
	"address": `ReceiptInfo_address__GV0ZF`,
	"payment": `ReceiptInfo_payment__s73Fw`,
	"productRow": `ReceiptInfo_productRow__BqahE`,
	"productContainer": `ReceiptInfo_productContainer__9srsz`,
	"textWrapper": `ReceiptInfo_textWrapper__euP0F`,
	"productName": `ReceiptInfo_productName__Rnrvt`,
	"productQty": `ReceiptInfo_productQty__+VhvO`,
	"progressBase": `ReceiptInfo_progressBase__41SM6`,
	"progressBg": `ReceiptInfo_progressBg__hgTnn`,
	"time": `ReceiptInfo_time__WoqD-`,
	"rowBottom": `ReceiptInfo_rowBottom__I5+5j`,
	"rowInfo": `ReceiptInfo_rowInfo__LaTJw`,
	"rowActions": `ReceiptInfo_rowActions__Q81XJ`,
	"bi-map": `ReceiptInfo_bi-map__YB+Lf`,
	"bi-file-earmark-text": `ReceiptInfo_bi-file-earmark-text__SNON+`,
	"icon": `ReceiptInfo_icon__obzjt`,
	"targetIcon": `ReceiptInfo_targetIcon__Ny-V+`,
	"sequenceNumber": `ReceiptInfo_sequenceNumber__19lky`,
	"nextSequence": `ReceiptInfo_nextSequence__xM9EK`,
	"fadedSequence": `ReceiptInfo_fadedSequence__+usqI`
};
export default ___CSS_LOADER_EXPORT___;
